import { render, staticRenderFns } from "./popup-bind.vue?vue&type=template&id=ec511ff8&scoped=true"
import script from "./popup-bind.vue?vue&type=script&lang=js"
export * from "./popup-bind.vue?vue&type=script&lang=js"
import style0 from "./popup-bind.vue?vue&type=style&index=0&id=ec511ff8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec511ff8",
  null
  
)

export default component.exports